<template>
  <div v-if="mesFacturacion">
    <v-container fluid grid-list-xs>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <Boton :id="'btnNew' + baseCotizacion" :onclick="newClick">{{
          $t('message.cuotas.periodo.anadir' + this.baseCotizacion)
        }}</Boton>
      </v-toolbar>
      <v-data-table
        :id="id"
        :headers="fields"
        :items="data"
        :no-data-text="$t('message.cuotas.periodo.sinPeriodos')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!-- <td class="text-xs-left">{{ props.item.nombre }}</td> -->
          <td class="text-xs-center">{{ props.item.periodoConsumo | moment('DD-MMMM-YYYY') }}</td>
          <td class="text-xs-right">
            <Numeric
              :id="'facturacion' + props.item.id"
              v-model="props.item.facturacion"
              :readonly="true"
            ></Numeric>
          </td>
          <td class="text-xs-right" v-if="kwhVisible">
            <Numeric
              :id="'nukwhfac' + props.item.id"
              v-model="props.item.nukwhfac"
              :precision="0"
              :readonly="true"
            ></Numeric>
          </td>
          <td class="text-xs-right">
            <Numeric
              :id="'tipo' + props.item.id"
              v-model="props.item.tipo"
              :readonly="true"
              :precision="precisionTipo"
            ></Numeric>
          </td>
          <td class="text-xs-right">
            <Numeric
              :id="'cuotaTributaria' + props.item.id"
              v-model="props.item.cuotaTributaria"
              :readonly="true"
            ></Numeric>
          </td>

          <td class="text-xs-center">
            <Icono
              :id="'editar' + baseCotizacion + props.item.id"
              :payload="props.item"
              color="info"
              class="mr-2"
              :tooltip="$t('message.cuotas.periodo.modificar' + baseCotizacion)"
              @click="editClick"
              >edit</Icono
            >
            <Icono
              :id="'eliminar' + baseCotizacion + props.item.id"
              :payload="props.item"
              color="error"
              :tooltip="$t('message.cuotas.periodo.eliminar')"
              @click="removeClick"
              >delete</Icono
            >
          </td>
        </template>

        <!-- Footer -->
        <template slot="footer">
          <td class="text-xs-left total"><strong>Total</strong></td>

          <td class="text-xs-right total" total>
            <Numeric id="totalfacturacion" :value="totalFacturacionble" readonly></Numeric>
          </td>
          <td class="text-xs-right total" total v-if="kwhVisible">
            <Numeric
              id="totalKwhFacturados"
              :value="totalKwhFacturados"
              :precision="0"
              readonly
            ></Numeric>
          </td>
          <td class="text-xs-center"></td>
          <td class="text-xs-right total" total>
            <Numeric id="totalCuotaTributaria" :value="totalCuotaTributaria" readonly></Numeric>
          </td>
          <td class="text-xs-right"></td>
        </template>
      </v-data-table>
    </v-container>

    <!-- Info modal -->
    <Modal id="modalPeriodo" :modalShow="modalShow" size="900" :title="modalTitle">
      <PeriodoGasCuota
        :model="rowSelected"
        :mesFacturacion="mesFacturacion"
        :kwhVisible="kwhVisible"
        :mode="mode"
        @modify="modificarHandler"
        @cancel="cancelarHandler"
      ></PeriodoGasCuota>
    </Modal>
  </div>
</template>
<script>
import { Numeric, Boton, Modal, CampoSelect, Icono } from '@/components';
import PeriodoGasCuota from './PeriodoGasCuota';
import { BASECOTIZACION_CUOTAS, PERIODO_CUOTA_INIT } from '../cuotasConst';
import { notificarWarning } from '@/utils/notification';
export default {
  name: 'periodosGasCuotas',
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    mesFacturacion: {
      type: Date
    },
    baseCotizacion: {
      // peaje o gas
      type: Number,
      required: true
    }
  },
  components: {
    Numeric,
    Boton,
    Modal,
    CampoSelect,
    PeriodoGasCuota,
    Icono
  },
  data() {
    let fields = [
      {
        value: 'periodo',
        text: this.$t('message.cuotas.periodo.periodo'),
        align: 'center',
        sortable: false
      },
      {
        value: 'facturacion',
        text: this.$tc('message.cuotas.periodo.facturacion', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'nukwhfac',
        text: this.$t('message.cuotas.periodo.nukwhfac'),
        align: 'right',
        sortable: false
      },
      {
        value: 'tipo',
        text: this.$tc('message.cuotas.periodo.tipo', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'cuotaTributaria',
        text: this.$tc('message.cuotas.periodo.cuotaTributaria', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'actions',
        text: this.$t('message.cuotas.periodo.actions'),
        align: 'center',
        sortable: false
      }
    ];
    return { mode: 'new', rowSelected: {}, modalShow: false, fields: fields, precisionTipo: 3 };
  },
  computed: {
    kwhVisible() {
      return this.baseCotizacion === BASECOTIZACION_CUOTAS.GAS;
    },
    totalFacturacionble() {
      let totalBaseImponible = this.data.reduce((total, item) => {
        return total + item.facturacion;
      }, 0);
      return totalBaseImponible;
    },
    totalKwhFacturados() {
      let totalBaseImponible = this.data.reduce((total, item) => {
        return total + item.nukwhfac;
      }, 0);
      return totalBaseImponible;
    },
    totalCuotaTributaria() {
      let totalBaseImponible = this.data.reduce((total, item) => {
        return total + item.cuotaTributaria;
      }, 0);
      return totalBaseImponible;
    },
    modalTitle() {
      return this.mode === 'new'
        ? this.$t('message.cuotas.periodo.anadir' + this.baseCotizacion)
        : this.$t('message.cuotas.periodo.modificar' + this.baseCotizacion);
    }
  },
  methods: {
    // Acciones tabla
    newClick() {
      this.mode = 'new';
      Object.assign(this.rowSelected, PERIODO_CUOTA_INIT);
      this.rowSelected.idBaseCo = this.baseCotizacion;
      this.rowSelected.id = this.data.length + 1;
      this.modalShow = true;
    },
    editClick(item) {
      this.mode = 'modify';
      this.rowSelected = item;
      this.modalShow = true;
    },
    removeClick(item) {
      this.$emit('remove', item);
    },
    // Acciones dialogo
    modificarHandler(payload) {
      // Checkeamos pk única
      var index = this.data.findIndex(function(item) {
        return (
          item.id != payload.id &&
          item.periodoConsumo.getTime() === payload.periodoConsumo.getTime()
        );
      });
      if (index === -1) {
        this.$emit('modify', payload);
        this.rowSelected = {};
        this.modalShow = false;
      } else {
        ++index;
        notificarWarning(
          this,
          'Periodo duplicado',
          'El periodo ha sido elegido en la fila '.concat(index.toString())
        );
      }
    },
    cancelarHandler() {
      this.rowSelected = {};
      this.modalShow = false;
    }
  },
  created() {
    if (!this.kwhVisible) {
      // Eliminamos la columna de kwh de la tabla (que es la segunda).
      this.fields.splice(2, 1);
    }
  }
};
</script>
